import { render, staticRenderFns } from "./meal-item.vue?vue&type=template&id=1f15f5b6&scoped=true&"
import script from "./meal-item.vue?vue&type=script&lang=js&"
export * from "./meal-item.vue?vue&type=script&lang=js&"
import style0 from "./meal-item.vue?vue&type=style&index=0&id=1f15f5b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f15f5b6",
  null
  
)

export default component.exports